import { useEffect } from 'react';
import PropTypes from 'prop-types';

import { useEcommerceManagerFactory } from '@spotahome/ecommerce-tracking';

import Homecard from '@spotahome/marketplace-common/src/components/Homecard';
import { getMonthlyPrice } from '@spotahome/marketplace-common/src/utils/homecards';
import { HomecardFormatter } from '@spotahome/ui-library/src/tenant/utils/images';

import { ListingShape } from '@spotahome/marketplace-common/src/shapes/listing';

import './OtherRooms.scss';

const OtherRooms = ({
  otherRooms,
  mainListing,
  locale = '',
  isLogged = false
}) => {
  const ecommerceManager = useEcommerceManagerFactory();

  useEffect(() => {
    try {
      ecommerceManager.trackExtraRoomsImpressions(otherRooms, mainListing);
    } catch (err) {
      console.error('Failed to track impressions at OtherRooms', {
        err
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleHomecardClick = (homecard, position) => () => {
    try {
      ecommerceManager.trackExtraRoomClick(
        homecard,
        mainListing,
        isLogged,
        locale,
        position
      );
    } catch (err) {
      console.error('Failed to handleHomecardClick at additionalListings', {
        err
      });
    }
  };

  return (
    <div className="additional-listings__container">
      {otherRooms.map((homecard, position) => (
        <div key={homecard.id} className="additional-listings__homecard">
          <Homecard
            key={`additional-listings-${homecard.id}`}
            position={position}
            data={{
              ...homecard,
              title: homecard.cardTitle,
              city: mainListing.cityId,
              photos: HomecardFormatter.getPhotos(
                homecard.photoIds,
                homecard.otherPropertyPhotoIds
              ),
              photoUrls: HomecardFormatter.getPhotoUrls(homecard.photoIds),
              monthlyPrice: getMonthlyPrice(homecard.displayPrice)
            }}
            onClick={handleHomecardClick(homecard, position)}
            hasLazyLoad
            pageType="product_page"
            section="other_rooms"
          />
        </div>
      ))}
    </div>
  );
};

OtherRooms.propTypes = {
  otherRooms: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string
    })
  ).isRequired,
  mainListing: PropTypes.shape(ListingShape).isRequired,
  locale: PropTypes.string,
  isLogged: PropTypes.bool
};

export default OtherRooms;
